import { getDateDiffInDays } from "./getDateDiffInDays";

export function getDateDiffText(data){
    const diff = getDateDiffInDays(data);

    if(diff > 0){
        return `(vence daqui ${diff} ${diff === 1 ? 'dia' : 'dias'})`
    }

    if(diff < 0){
        const abs = Math.abs(diff);
        return `(vencido há ${abs} ${abs === 1 ? 'dia' : 'dias'})`
    }

    if(diff === 0){
        return `(vence hoje)`
    }
}
